$('.giftcard-buy').on('click', function () {
	let priceId = $(this).data('price-id');
	let credits = $(this).data('credits');
	let amount = $(this).data('amount');

	window.gc_price_id = priceId;

	// NEW: Update modal header text
	$('#gc_credits_amount').text(credits);
	$('#gc_credits_price').text(amount);

	// Reset steps
	$('.step').hide();
	$('#gc-step-details').show();

	$('body').addClass('menu-open');
	$('.modal__giftcards-payment').addClass('open');
});

$('#gc-details-next').on('click', function (e) {
	e.preventDefault();

	let data = $('#gc-details-form').serialize()
			  + '&price_id=' + window.gc_price_id;

	showLoader();
	$.post('/giftcards/create-intent/', data, function (res) {
		hideLoader();

		if (res.status === 'success') {

			// Store for next step
			window.gc_giftcard_id = res.giftcard_id;

			$('#gc-payment-form')
				.attr('data-client-secret', res.client_secret)
				.attr('data-giftcard-id', res.giftcard_id)
				.attr('data-stripe-publishable-key', res.publishable_key);

			$('#gc-price').text(res.price_amount);

			$('.step').hide();
			$('#gc-step-payment').show();

			setTimeout(initGiftcardStripe, 50);
		}
		else {
			$('#gc-details-error').text(res.message);
		}
	}, 'json');
});

let gcStripe, gcNum, gcExp, gcCvc;

function initGiftcardStripe() {

	const form = document.getElementById('gc-payment-form');
	const pk   = form.dataset.stripePublishableKey;
	const cs   = form.dataset.clientSecret;

	if (!pk || !cs) return;

	gcStripe = Stripe(pk);

	const elements = gcStripe.elements({
		appearance: {
			theme: 'night'
		}
	});
	const style = { base: { lineHeight: '44px' } };

	gcNum = elements.create('cardNumber', { style });
	gcExp = elements.create('cardExpiry', { style });
	gcCvc = elements.create('cardCvc', { style });

	gcNum.mount('#gc-card-number-element');
	gcExp.mount('#gc-card-expiry-element');
	gcCvc.mount('#gc-card-cvc-element');



	$('#gc-submit').off('click').on('click', function (e) {
		e.preventDefault();

		gcStripe.confirmCardPayment(cs, {
			payment_method: { card: gcNum }
		}).then(result => {

			if (result.error) {
				$('#gc-error-message').text(result.error.message);
			} else if (result.paymentIntent.status === 'succeeded') {
				gc_afterPaymentSuccess();
			}
		});
	});
}

function gc_afterPaymentSuccess() {

	showLoader();
	$.get(`/giftcards/markpaid/${window.gc_giftcard_id}/`, function (res) {

		console.log(res);

		hideLoader();

		// Fetch final info (code + PDF URL)
		$.get(`/giftcards/get-info/${window.gc_giftcard_id}/`, function (info) {

			console.log(info);

			$('#gc-final-code').text(info.data.gift_code);
			$('#gc-download-pdf').attr('href', info.data.pdf_url);

			$('.step').hide();
			$('#gc-step-complete').show();
		});

	}, 'json');
}

$('#gc-complete-close').on('click', function () {
	location.reload();
});

$('.giftcard-close').on('click', function () {
	$('body').removeClass('menu-open');
	$('.modal__giftcards-payment').removeClass('open');
});

$('#gc-apply-voucher').off('click').on('click', function () {
	let code = $('#gc-voucher-code').val().trim();

	if (!code) {
		return $('#gc-details-error').text('Please enter a code.');
	}

	showLoader();
	$.post('/giftcards/apply-voucher/', {
		voucher_code: code,
		giftcard_id: window.gc_giftcard_id
	}, function (res) {
		hideLoader();

		console.log(res);

		if (res.status === 'success') {

			$('#gc-details-error').text('');
			$('#gc-voucher-code').closest('.form-group').hide();

			const discountLabel =
				res.type === 'percent'
					? `${res.data.amount}%`
					: `${parseFloat(res.data.amount).toFixed(2)}`;

			const appliedHtml = `
				<div id="gc-promo-applied" class="mt-2">
					<strong>${code}</strong> – ${discountLabel} off
					<a href="#" id="gc-remove-voucher" class="ml-2" style="color:red;">
						<i class="fa fa-trash"></i> Remove
					</a>
				</div>
			`;

			$('#gc-voucher-code').closest('.form-group').after(appliedHtml);

			$('#gc_credits_price').text(res.data.new_price);

		} else {
			$('#gc-details-error').text(res.message);
		}
	}, 'json');
});

$(document).on('click', '#gc-remove-voucher', function (e) {
	e.preventDefault();

	showLoader();
	$.post('/giftcards/remove-voucher/', {
		giftcard_id: window.gc_giftcard_id
	}, function (res) {
		hideLoader();

		if (res.status === 'success') {

			$('#gc-promo-applied').remove();
			$('#gc-voucher-code')
				.closest('.form-group')
				.show();

			$('#gc-voucher-code').val('');
			$('#gc-details-error').text('Voucher removed.');

			$('#gc_credits_price').text(res.data.original_price);

		} else {
			$('#gc-details-error').text(res.message);
		}
	}, 'json');
});